/* 
 * check user phone input and autofill separator "-"
 */
export function checkPhoneInput(currentInput, previousInput) {
    let result = currentInput;
    if (currentInput.length === 0)
      return result;
    let lastChar = currentInput[currentInput.length-1];
    const regex = /[0-9]/;
    // delete user current input if it is not a number (need deal with '-')
    if (!lastChar.match(regex)) {
      if (lastChar === "-") {
        if (currentInput.length !== 4 && currentInput.length !== 8)
          result = currentInput.slice(0, -1);
      }
      else
        result = currentInput.slice(0, -1);
    }
    else {
      // autofill the "-" between number to form xxx-xxx-xxxx
      if (previousInput) {
        if ((previousInput.length === 2 && currentInput.length === 3) || (previousInput.length === 6 && currentInput.length === 7))
        result += "-";
      }
    }
    return result; 
  }

/**
 * format phone number into (xxx)-xxx xxxx
 * @param {String} phone 
 * @param {String} countryCode 
 * @returns {String} formatted phone number
 */
export function formatPhoneNumber(phone, countryCode) {
  if (!phone) {
    return "";
  }
  let modifiedPhone = phone.replace(/\D/g, '');
  // console.log("🌲 formatPhoneNumber countryCode:", countryCode);
  // console.log("🌲 formatPhoneNumber modifiedPhone:", modifiedPhone);

  // If country code is not +1 (US/Canada/Others), return the phone number as is.
  if (countryCode !== '+1') {
    return modifiedPhone;
  }
  // if phone number length is less than 10, return the phone number as is
  if (modifiedPhone.length < 10) {
    return phone;
  }
  // if country code is +1 (US/Canada), format the phone number into (xxx)-xxx xxxx
  let firstThreeNumber = modifiedPhone.slice(0, 3);
  let middleThreeNumber = modifiedPhone.slice(3, 6);
  let remaining = modifiedPhone.slice(6);
  return ["(", firstThreeNumber, ")", "-", middleThreeNumber, " ", remaining].join("");
}